import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { BlockDataForm } from '@plone/volto/components';
import { InfoboxBlockSchema } from './schema';

const IntroductionBlockData = (props) => {
  const { block, data, onChangeBlock, contentType, navRoot } = props;
  const intl = useIntl();
  const schema = InfoboxBlockSchema({ ...props, intl });

  return (
    <>
      <BlockDataForm
        schema={schema}
        title={schema.title}
        onChangeField={(id, value) => {
          onChangeBlock(block, {
            ...data,
            [id]: value,
          });
        }}
        formData={data}
        block={block}
        navRoot={navRoot}
        contentType={contentType}
      />
    </>
  );
};

IntroductionBlockData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default IntroductionBlockData;
